import { CrmSegmentContactDto } from '../models/crm-segment-contact.dto';
import { SegmentContactRow } from '../models/segment-contact-row.model';

export function toSegmentContactRow(contact: CrmSegmentContactDto): SegmentContactRow {
  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim();
  const phoneNumber = contact.defaultPhoneNumber ?? '';

  return fullName
    ? { id: contact.id, fullName, phoneNumber }
    : { id: contact.id, fullName: phoneNumber, phoneNumber: '' };
}
